import { SITE_PRIMARY_COLOR, SITE_SECONDARY_COLOR } from '../../constants';

import React from 'react';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import createTheme from '@mui/material/styles/createTheme';

type ChildElement = JSX.Element | '' | false | undefined;

export interface ObservodonThemeProps {
  children: ChildElement | ChildElement[];
}

export const theme = createTheme({
  typography: { fontFamily: 'Poppins,Helvetica,Arial,sans-serif' },
  palette: {
    primary: { main: SITE_PRIMARY_COLOR },
    secondary: { main: SITE_SECONDARY_COLOR }
  }
});

/**
 * Theme provider for the Observodon brand.
 */
const ObservodonTheme = (props: ObservodonThemeProps) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default ObservodonTheme;
